module.exports = __webpack_public_path__ + "static/media/bishop3.40fca1fc.jpg";